import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API_URL } from "@/lib/api";
import { useSite } from "@/context/SiteContext";

/**
 * "Real Projects. Real Results." — renders only verified, published case
 * studies. With none published, the section stays hidden rather than showing
 * placeholders, and the Projects page explains what's coming.
 */
export default function ProjectsSection({ compact = false }) {
  const { config } = useSite();
  const [projects, setProjects] = useState(null);
  useEffect(() => {
    let alive = true;
    fetch(`${API_URL}/projects`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (alive) setProjects((d && d.projects) || []);
      })
      .catch(() => alive && setProjects([]));
    return () => {
      alive = false;
    };
  }, []);

  if (!projects || !projects.length) return null;
  return (
    <section className="section" id="projects" style={{ paddingTop: compact ? 30 : undefined }}>
      <div className="wrap">
        <div className="section-heading">
          <div>
            <span className="eyebrow">VERIFIED WORK</span>
            <h2>Real Projects. Real Results.</h2>
          </div>
          <p>
            Jobs we've done, published only — each with verified details and photographs we're authorized to share.
            <Link to="/projects" style={{ color: "var(--teal)", fontWeight: 800 }}> See jobs we've done ↗</Link>
          </p>
        </div>
        <div className="cards-grid" data-testid="projects-grid">
          {projects.slice(0, compact ? 3 : 6).map((p) => (
            <Link key={p.slug} to={`/projects/${p.slug}`} className="service-card" style={{ color: "inherit", height: "100%" }} data-testid={`project-card-${p.slug}`}>
              {p.photoKeys && p.photoKeys[0] ? (
                <img src={`${API_URL}/projects/photo/${p.photoKeys[0]}`} alt={`${p.title} — approved project photograph`} style={{ width: "100%", height: 150, objectFit: "cover", borderRadius: 10 }} loading="lazy" />
              ) : null}
              <h3>{p.title}</h3>
              <p>
                {[p.city, p.state].filter(Boolean).join(", ")}
                {p.propertyType ? ` · ${p.propertyType}` : ""}
              </p>
              <p>
                {p.systemKw ? `${p.systemKw} kW system` : "System size on request"}
                {p.batteryKwh ? ` · ${p.batteryKwh} kWh battery` : ""}
                {p.completionDate ? ` · completed ${p.completionDate}` : ""}
              </p>
              {p.annualGenerationMeasuredKwh ? (
                <p>
                  <b>Measured:</b> {Number(p.annualGenerationMeasuredKwh).toLocaleString()} kWh/yr
                </p>
              ) : p.annualGenerationEstKwh ? (
                <p>
                  <b>Estimated:</b> {Number(p.annualGenerationEstKwh).toLocaleString()} kWh/yr
                </p>
              ) : null}
              <span className="go">Read the case study ↗</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
